import { merge } from 'lodash';
import { forwardRef } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { Link } from 'hb-react/frontoffice/components/Link';

const ButtonInLink = forwardRef(
  (
    {
      children,
      largeButton,
      wrapperProps,
      linkProps,
      buttonProps,
      isDisabled,
      ...otherProps
    },
    ref,
  ) => {
    const defaultLinkProps = {
      style: { display: 'inline-flex' },
    };

    const size = largeButton ? 'large' : 'normal';

    const updatedLinkProps = merge({}, defaultLinkProps, linkProps);

    return (
      <Box {...wrapperProps}>
        {isDisabled ? (
          <Button
            as="span"
            size={size}
            type={null}
            {...buttonProps}
            {...otherProps}
            isDisabled
            ref={ref}
          >
            {children}
          </Button>
        ) : (
          <Link {...updatedLinkProps}>
            <Button
              as="span"
              size={size}
              type={null}
              {...buttonProps}
              {...otherProps}
              ref={ref}
            >
              {children}
            </Button>
          </Link>
        )}
      </Box>
    );
  },
);

ButtonInLink.defaultProps = {
  wrapperProps: {},
  linkProps: {},
  buttonProps: {},
  isDisabled: false,
};

export default ButtonInLink;
